import {
  cleanDoubleSlashes,
  hasTrailingSlash,
  joinURL,
  parseURL,
  withTrailingSlash,
} from "ufo";

export function needToNormalize(url: string): boolean {
  const parsedUrl = parseURL(url);
  const pathname = parsedUrl.pathname ?? "/";

  // служебные Remix и системные URL
  if (
    pathname.includes("__manifest") ||
    /^\/(api|loader|resource|cms-assets|assets|\.well-known|\.css|\.png|\.jpg|\.jpeg|\.svg|\.json)\b/.test(
      pathname,
    ) ||
    /\.data($|\?)/.test(pathname)
  ) {
    return false;
  }

  // статические файлы (.js, .png, .css и т.п.)
  if (/\.[a-zA-Z0-9]+(?=($|\?|#))/.test(pathname)) {
    return false;
  }

  // service workers, manifest.json и т.п.
  if (/(manifest|service-worker|sw)\.(json|js)(\?|#|$)/i.test(pathname)) {
    return false;
  }

  if (/[^:]\/\/{2,}/.test(url)) {
    return true;
  }
  // если нет завершающего /

  if (pathname === "/") return false;
  return !hasTrailingSlash(pathname);
}

/**
 * Нормализует URL:
 * - убирает двойные слеши
 * - добавляет завершающий `/`, если его нет
 * - сохраняет query и hash
 * - корректно работает с абсолютными и относительными URL
 */
export function normalizeUrl(url: string): string {
  const parsed = parseURL(url);

  // Убираем двойные слеши внутри пути
  let path = parsed.pathname || "/";

  // Добавляем завершающий `/`, если его нет
  if (!hasTrailingSlash(path)) {
    path = withTrailingSlash(path);
  }

  // Собираем обратно
  const base = parsed.protocol
    ? `${parsed.protocol}//${parsed.host ?? ""}`
    : "";

  return cleanDoubleSlashes(
    joinURL(base, path + (parsed.search ?? "") + (parsed.hash ?? "")),
  );
}
